import TypeUtils from '@/helpers/type-utils';
import {AvailablePeriodType} from "@/data/models/enums/available-period-type";

export default class StatsForm {
  startDate: Date;
  buildingId: string;
  metersIds: string[];
  period: AvailablePeriodType;

  static map(data: Partial<StatsForm>): StatsForm {
    if (!data) {
      return null;
    }

    const statsForm: StatsForm = new StatsForm();

    statsForm.startDate = TypeUtils.hasDateOrDefault(data.startDate);
    statsForm.buildingId = TypeUtils.hasStringOrDefault(data.buildingId);
    statsForm.period = TypeUtils.hasEnumOrDefault(data.period, AvailablePeriodType);
    statsForm.metersIds = TypeUtils.hasArrayOrDefault(data.metersIds, []);

    return statsForm;
  }

  toJSON(): { startDate: Date, buildingId: string, metersIds: string[], period: AvailablePeriodType } {
    return {
      'startDate': this.startDate,
      'buildingId': this.buildingId,
      'metersIds': this.metersIds,
      'period': this.period
    };
  }
}
